@if (form) {
	<form [formGroup]="form">
		<p class="u-m-bottom--sm">{{ 'BOOKING.OH_CONTACTS.CONFIRMATION' | translate }}</p>

		<ng-container formGroupName="booker">
			<tvcore-checkbox class="u-m-bottom--xxs" name="bookingConfirmations">
				{{ form.value['booker'].name }}
			</tvcore-checkbox>
		</ng-container>

		<ng-container formArrayName="guide">
			@for (group of guide.controls; track group) {
				<ng-container [formGroupName]="$index">
					<tvcore-checkbox class="u-m-bottom--xxs" name="bookingConfirmations">
						{{ group.value.name }}
					</tvcore-checkbox>
				</ng-container>
			}
		</ng-container>

		<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'BOOKING.OH_CONTACTS.OTHERS_TITLE' | translate }}</p>
		<p class="u-m-bottom--sm" [innerHTML]="'BOOKING.OH_CONTACTS.OTHERS_DESCRIPTION' | translate"></p>

		<div formArrayName="other">
			@for (group of other.controls; track group) {
				<div class="c-other u-m-bottom--sm" [formGroupName]="$index">
					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FULL_NAME' | translate" name="fullName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<button class="c-btn-link c-btn--with-icon" (click)="removeOther($index)" type="button">
						<tvcore-icon name="trash"></tvcore-icon>
						{{ 'BOOKING.OH_CONTACTS.REMOVE_OTHER_BUTTON' | translate }}
					</button>
				</div>
			}

			<button class="c-btn-link c-btn--with-icon" (click)="addOther()" type="button">
				<tvcore-icon name="plus"></tvcore-icon>
				{{ 'BOOKING.OH_CONTACTS.ADD_OTHER_BUTTON' | translate }}
			</button>
		</div>
	</form>
}
